function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M254.812 101.975C254.631 79.9568 249.072 58.0916 235.287 41.7913C221.503 25.491 199.402 14.6276 176.498 13.7931C176.015 13.7753 175.529 13.7647 175.043 13.754C175.078 13.8393 175.117 13.928 175.153 14.0168C176.008 16.1937 171.833 20.4446 168.227 20.4446C166.118 20.4446 162.902 19.2372 161.961 18.669V18.6299C161.56 20.1017 160.969 21.515 160.204 22.8346C156.775 28.7794 150.658 31.7128 146.271 29.6708C145.611 30.6083 144.851 31.8442 144.166 32.938C147.52 35.47 150.201 39.2344 150.201 43.0094C150.201 43.4604 150.183 43.9363 150.154 44.4299C153.076 46.8092 155.305 54.7286 154.769 58.1449C154.491 58.4684 154.173 58.7548 153.821 58.9972C154.333 62.5485 155.458 70.3612 156.04 71.3911C156.693 72.5453 175.035 101.36 176.512 103.562C178.887 103.31 181.127 105.252 181.532 107.994C181.958 110.803 180.325 113.381 177.882 113.754C175.44 114.127 173.111 112.149 172.685 109.34C172.55 108.477 172.616 107.595 172.877 106.762C172.816 106.765 172.754 106.765 172.693 106.762C171.226 105.718 160.499 92.1838 155.405 85.7027C159.182 94.0837 163.598 103.793 164.609 106.19C166.938 106.293 169.015 108.346 169.441 111.162C169.917 114.28 168.163 117.131 165.536 117.533C162.909 117.934 160.374 115.732 159.902 112.614C159.715 111.437 159.861 110.232 160.325 109.134C160.176 109.098 160.027 109.066 159.87 109.02C157.293 106.914 141.699 86.5621 138.269 80.8623C134.134 89.428 130.023 96.0049 127.893 96.5021C121.202 98.0753 101.23 80.0988 97.9713 74.0901L93.5588 79.9639L67.8115 60.6095C50.9958 73.9729 36.9276 89.95 32.7636 108.481C25.8733 138.752 45.4509 175.766 73.9741 205.32C102.433 234.874 139.899 256.963 169.87 249.558C199.842 242.154 222.362 205.32 236.139 175.766C249.917 146.213 255.053 123.939 254.812 101.975Z",
  fill: "#EDF0F3"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M137.421 29.9265C139.085 27.4892 140.604 24.9564 141.972 22.341C141.92 21.3134 141.982 20.2832 142.156 19.2692C138.564 20.4529 134.908 21.8225 131.187 23.378L134.283 25.7076L128.958 32.8101C131.755 30.9635 134.283 29.8626 136.342 29.8626C136.702 29.8615 137.063 29.8828 137.421 29.9265Z",
  fill: "#EDF0F3"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M115.387 192.514L113.694 194.045L109.938 189.805C108.529 189.494 107.076 189.438 105.646 189.638L111.081 191.903L119.644 201.137C119.547 199.488 119.121 197.875 118.39 196.394C117.659 194.912 116.638 193.593 115.387 192.514Z",
  fill: "#E0E5EC"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M105.203 167.975L108.128 170.979L96.6547 110.8L92.3594 111.62L103.399 169.591C104.248 168.82 104.919 168.209 105.203 167.975Z",
  fill: "#E0E5EC"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M99.92 199.084C99.92 199.084 103.75 190.426 104.389 189.109L110.573 191.687C110.996 190.501 111.358 189.464 111.638 188.654C111.638 188.654 64.9609 185.671 57.8398 185.671L59.2846 192.024C59.2846 192.024 99.7035 210.8 103.072 211.762C103.072 211.762 104.755 207.373 106.672 202.273L99.92 199.084Z",
  fill: "#E0E5EC"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M120.936 202.504L192.565 147.662L188.629 142.512L116.506 197.735L120.936 202.504Z",
  fill: "#E0E5EC"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M99.9202 199.084C99.9202 199.084 102.799 192.571 103.981 189.986C102.02 190.541 100.228 191.573 98.7624 192.99C97.2973 194.407 96.2055 196.164 95.5844 198.106C94.9634 200.047 94.8324 202.113 95.2031 204.117C95.5739 206.122 96.4348 208.003 97.7092 209.594C98.9835 211.185 100.632 212.435 102.507 213.234C104.381 214.033 106.425 214.355 108.454 214.171C110.484 213.988 112.436 213.305 114.138 212.183C115.839 211.061 117.237 209.535 118.206 207.742L99.9202 199.084Z",
  fill: "#E0E5EC"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M162.431 16.1689C162.431 16.2438 162.431 16.3187 162.409 16.3935C162.413 16.3115 162.42 16.2367 162.431 16.1689Z",
  fill: "#EDF0F3"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M98.287 73.6427L64.084 47.9351",
  stroke: "#EDF0F3",
  strokeWidth: 7,
  strokeMiterlimit: 10
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M129.576 31.9791L95.373 6.27502",
  stroke: "#EDF0F3",
  strokeWidth: 7,
  strokeMiterlimit: 10
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M99.6113 48.9968C103.13 48.9968 105.983 46.1429 105.983 42.6223C105.983 39.1018 103.13 36.2478 99.6113 36.2478C96.0921 36.2478 93.2393 39.1018 93.2393 42.6223C93.2393 46.1429 96.0921 48.9968 99.6113 48.9968Z",
  fill: "#EDF0F3"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M110.694 50.5636L110.823 50.4067L110.694 50.5636Z",
  fill: "#EDF0F3"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M108.319 53.5575L108.483 53.3472L108.319 53.5575Z",
  fill: "#EDF0F3"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M105.529 57.2997L105.753 56.9872L105.529 57.2997Z",
  fill: "#EDF0F3"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M106.537 55.9189C106.58 55.8654 106.619 55.8084 106.662 55.7513C106.619 55.8084 106.594 55.8654 106.537 55.9189Z",
  fill: "#EDF0F3"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M107.681 54.3912L107.887 54.1213L107.681 54.3912Z",
  fill: "#EDF0F3"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M114.574 46.0115L114.625 45.9534L114.574 46.0115Z",
  fill: "#EDF0F3"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M107.066 55.2116C107.134 55.1192 107.201 55.0234 107.272 54.931C107.201 55.0234 107.134 55.1192 107.066 55.2116Z",
  fill: "#EDF0F3"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M97.5244 73.0176C97.5288 73.041 97.5348 73.0641 97.5426 73.0866C97.5348 73.0641 97.5288 73.041 97.5244 73.0176Z",
  fill: "#EDF0F3"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M104.95 58.1272C105.035 58.0065 105.121 57.8822 105.209 57.7721C105.121 57.8857 105.035 58.0065 104.95 58.1272Z",
  fill: "#EDF0F3"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M97.8154 70.9294C97.8651 70.7661 97.9148 70.5992 97.9716 70.4287C97.9148 70.5992 97.8651 70.7661 97.8154 70.9294Z",
  fill: "#EDF0F3"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M97.5168 72.4067C97.5168 72.5346 97.499 72.6589 97.499 72.7619C97.499 72.6589 97.5061 72.5346 97.5168 72.4067Z",
  fill: "#EDF0F3"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M97.7802 71.0574C97.7482 71.1746 97.7198 71.2882 97.6914 71.4125C97.7198 71.2882 97.7482 71.1746 97.7802 71.0574Z",
  fill: "#EDF0F3"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M97.656 71.558C97.6312 71.6574 97.6134 71.7533 97.5957 71.8492C97.6134 71.7533 97.6312 71.6574 97.656 71.558Z",
  fill: "#EDF0F3"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M97.5667 72.002C97.5667 72.0978 97.5419 72.1902 97.5312 72.2825C97.5419 72.1902 97.5525 72.0907 97.5667 72.002Z",
  fill: "#EDF0F3"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M111.351 49.7644L111.465 49.6254L111.351 49.7644Z",
  fill: "#EDF0F3"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M99.7852 66.3804L100.016 65.9507L99.7852 66.3804Z",
  fill: "#EDF0F3"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M98.4688 69.1289C98.522 68.9975 98.5788 68.8697 98.6356 68.7383C98.5788 68.8697 98.522 68.9975 98.4688 69.1289Z",
  fill: "#EDF0F3"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M98.7236 68.5395L98.9544 68.0424L98.7236 68.5395Z",
  fill: "#EDF0F3"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M99.416 67.0905C99.4941 66.9378 99.5722 66.7887 99.6503 66.6324C99.5722 66.7887 99.4941 66.9378 99.416 67.0905Z",
  fill: "#EDF0F3"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M99.0078 67.9215C99.1037 67.7156 99.2066 67.506 99.3131 67.293C99.2066 67.506 99.1037 67.7156 99.0078 67.9215Z",
  fill: "#EDF0F3"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M98.0107 70.315C98.0569 70.1765 98.1066 70.0345 98.1634 69.8925C98.1066 70.0416 98.0746 70.1836 98.0107 70.315Z",
  fill: "#EDF0F3"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M98.2344 69.7078C98.2805 69.587 98.3302 69.4628 98.3799 69.3527C98.3302 69.4628 98.2805 69.6048 98.2344 69.7078Z",
  fill: "#EDF0F3"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M101.582 63.2445L101.855 62.7935L101.582 63.2445Z",
  fill: "#EDF0F3"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M103.065 60.8971C103.225 60.6521 103.388 60.407 103.555 60.1584C103.399 60.407 103.225 60.6521 103.065 60.8971Z",
  fill: "#EDF0F3"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M102.064 62.4596L102.334 62.0299L102.064 62.4596Z",
  fill: "#EDF0F3"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M102.558 61.682L102.845 61.2345L102.558 61.682Z",
  fill: "#EDF0F3"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M103.808 59.782L104.092 59.3665L103.808 59.782Z",
  fill: "#EDF0F3"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M100.162 65.6985C100.244 65.5493 100.329 65.3966 100.418 65.2439C100.329 65.3788 100.244 65.5315 100.162 65.6985Z",
  fill: "#EDF0F3"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M100.56 64.9882C100.687 64.768 100.815 64.5443 100.95 64.317C100.812 64.5301 100.684 64.7538 100.56 64.9882Z",
  fill: "#EDF0F3"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M101.397 63.5428C101.28 63.7346 101.17 63.9264 101.042 64.1146C101.17 63.9228 101.269 63.7346 101.397 63.5428Z",
  fill: "#EDF0F3"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M104.383 58.951L104.642 58.5746L104.383 58.951Z",
  fill: "#EDF0F3"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M93.5981 105.828C91.5357 105.828 77.8118 104.002 77.1622 104.002C76.5126 104.002 74.9258 104.414 74.9258 105.476C74.9258 109.07 86.47 112.252 98.1952 112.252C109.92 112.252 93.5981 105.828 93.5981 105.828Z",
  fill: "#0B1B2D"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M55.1565 234.849C79.8789 234.849 99.9204 214.8 99.9204 190.067C99.9204 165.335 79.8789 145.286 55.1565 145.286C30.4341 145.286 10.3926 165.335 10.3926 190.067C10.3926 214.8 30.4341 234.849 55.1565 234.849Z",
  stroke: "#0B1B2D",
  strokeWidth: 16,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M214.844 234.849C239.566 234.849 259.608 214.8 259.608 190.067C259.608 165.335 239.566 145.286 214.844 145.286C190.122 145.286 170.08 165.335 170.08 190.067C170.08 214.8 190.122 234.849 214.844 234.849Z",
  stroke: "#0B1B2D",
  strokeWidth: 16,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M215.543 184.731L174.878 110.426L171.431 112.314L212.096 186.619L215.543 184.731Z",
  fill: "#E0E5EC"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M192.568 144.377H97.499V147.083H192.568V144.377Z",
  fill: "#E0E5EC"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M99.5344 142.226L52.2168 187.194L55.537 190.69L102.855 145.723L99.5344 142.226Z",
  fill: "#E0E5EC"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M105.203 167.975C104.099 168.934 97.1729 175.39 97.1729 175.39L113.694 194.045L116.747 191.271L110.258 173.16L105.203 167.975Z",
  stroke: "#0B1B2D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M155.412 85.6814C160.506 92.1624 171.234 105.696 172.7 106.74C172.762 106.744 172.823 106.744 172.885 106.74C172.624 107.574 172.558 108.456 172.693 109.319C173.119 112.128 175.448 114.102 177.89 113.733C180.332 113.364 181.965 110.782 181.539 107.973C181.121 105.231 178.895 103.289 176.52 103.541C175.043 101.339 156.701 72.5239 156.048 71.3698C155.466 70.3434 154.34 62.5129 153.829 58.9758",
  stroke: "#0B1B2D",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M150.155 44.4229C153.076 46.8022 155.306 54.7215 154.769 58.1378C153.066 60.1692 149.058 60.9362 146.782 60.8297",
  stroke: "#0B1B2D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M144.181 32.9486C147.532 35.4807 150.198 39.245 150.198 43.02C150.198 47.2815 148.778 53.4359 146.63 60.0661",
  stroke: "#0B1B2D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M138.267 80.8234C134.135 89.4316 130.024 96.005 127.894 96.5022C120.602 98.2175 97.5176 76.6968 97.5176 72.7762C97.5176 64.6545 124.852 29.8556 136.36 29.8556C136.716 29.8574 137.072 29.8811 137.425 29.9266",
  stroke: "#0B1B2D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M139.931 34.22C140.932 34.8557 141.968 35.3138 142.753 35.2854C143.296 34.4544 145 31.4997 146.281 29.6886",
  stroke: "#0B1B2D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M141.972 22.3409C140.604 24.957 139.084 27.491 137.421 29.93",
  stroke: "#0B1B2D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M141.162 40.7898C139.215 35.8543 136.552 31.2329 133.257 27.0748",
  stroke: "#0B1B2D",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M98.8057 72.3392C104.358 74.4132 121.482 72.4848 133.967 69.7539",
  stroke: "#0B1B2D",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M142.21 24.1841C141.888 22.6167 141.861 21.003 142.129 19.4254",
  stroke: "#0B1B2D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M162.43 16.1689C162.171 18.5259 161.416 20.8013 160.215 22.8453C156.665 29.0245 150.179 31.9685 145.767 29.4187C144.928 28.9315 144.202 28.2718 143.637 27.4833",
  stroke: "#0B1B2D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M143.158 13.7647C143.513 11.634 145.778 5.84897 149.211 4.05203C153.016 2.05267 155.405 3.40925 158.068 3.40925C160.46 3.40925 162.359 2.24444 164.997 2.4078C168.423 2.62087 168.852 6.01588 169.388 7.62461C170.098 9.75536 173.577 9.96844 175.171 14.0169C176.026 16.1938 171.852 20.4447 168.245 20.4447C166.137 20.4447 162.92 19.2372 161.98 18.669C162.178 17.8406 162.335 17.0026 162.448 16.1583C161.174 16.1583 153.286 14.578 152.643 14.6135C152.001 14.649 149.644 17.0426 149.427 17.5433C148.458 17.3803 147.5 17.1621 146.555 16.8899",
  stroke: "#0B1B2D",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M143.989 19.7344C143.836 19.757 143.681 19.7688 143.527 19.7699C143.019 19.77 142.519 19.6417 142.074 19.3969C141.629 19.152 141.253 18.7987 140.981 18.3696C140.709 17.9405 140.55 17.4496 140.519 16.9425C140.487 16.4354 140.584 15.9285 140.801 15.4689C141.017 15.0094 141.346 14.612 141.758 14.3138C142.169 14.0156 142.649 13.8262 143.153 13.7632C143.657 13.7001 144.168 13.7655 144.64 13.9533C145.112 14.1411 145.529 14.4451 145.852 14.8372",
  stroke: "#0B1B2D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M146.374 50.4849C147.286 52.8287 147.847 54.9488 147.914 56.4652C146.661 58.4965 133.449 63.3795 130.768 62.9889C126.864 58.4965 122.174 37.2848 130.293 34.0034C130.737 33.8235 131.209 33.7191 131.688 33.6945",
  stroke: "#0B1B2D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M131.798 62.964C133.157 66.7994 136.544 76.8353 137.648 79.687C138.869 82.8476 157.052 106.677 159.852 108.981C160.009 109.028 160.158 109.059 160.307 109.095C159.844 110.193 159.697 111.398 159.884 112.575C160.357 115.693 162.881 117.902 165.518 117.494C168.156 117.085 169.909 114.241 169.423 111.123C168.997 108.324 166.92 106.272 164.592 106.151C162.817 101.953 150.623 75.3544 149.657 72.691C148.791 70.3187 146.796 61.3979 146.175 57.7756",
  stroke: "#0B1B2D",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M104.39 189.109C103.751 190.426 99.9209 199.084 99.9209 199.084L122.463 209.738L124.177 205.988L111.092 191.9L104.39 189.109Z",
  stroke: "#0B1B2D",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M55.1563 196.208C58.5461 196.208 61.294 193.459 61.294 190.067C61.294 186.676 58.5461 183.927 55.1563 183.927C51.7665 183.927 49.0186 186.676 49.0186 190.067C49.0186 193.459 51.7665 196.208 55.1563 196.208Z",
  fill: "#0B1B2D"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M214.844 196.208C218.234 196.208 220.982 193.459 220.982 190.067C220.982 186.676 218.234 183.927 214.844 183.927C211.454 183.927 208.706 186.676 208.706 190.067C208.706 193.459 211.454 196.208 214.844 196.208Z",
  fill: "#0B1B2D"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M127.893 96.5021C120.871 98.1534 99.2171 78.2699 97.6125 73.2875C94.091 76.4517 86.9629 85.5607 86.9629 95.419C86.9629 109.837 115.919 132.384 126.398 139.455C124.375 144.693 104.336 187.727 103.679 189.751C105.241 191.04 109.931 192.788 111.677 192.788C121.326 185.064 148.166 144.135 148.628 140.19C149.008 136.898 133.289 106.549 127.999 96.4524C127.965 96.4716 127.93 96.4882 127.893 96.5021Z",
  fill: "#0B1B2D"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M131.06 93.5227C129.782 95.2451 128.685 96.314 127.865 96.5022C126.58 96.8041 124.805 96.385 122.753 95.4652C117.485 105.071 126.626 133.229 126.626 133.229C126.626 133.229 106.009 165.628 104.674 167.744C104.674 169.52 107.237 172.652 109.686 174.101C114.255 172.325 159.615 130.175 161.823 120.076C159.324 116.372 138.362 98.395 131.06 93.5227Z",
  fill: "#0B1B2D"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M160.012 113.158L157.013 114.223L158.032 117.089L161.429 115.881C160.74 115.104 160.253 114.168 160.012 113.158Z",
  fill: "#0B1B2D"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M181.539 107.987C181.573 108.229 181.593 108.474 181.6 108.718L186.701 106.907L185.682 104.052L180.733 105.81C181.147 106.473 181.421 107.214 181.539 107.987Z",
  fill: "#0B1B2D"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M173.537 111.581C173.1 110.9 172.812 110.133 172.692 109.333C172.661 109.113 172.639 108.893 172.629 108.676L169.143 109.915C169.499 110.912 169.607 111.981 169.459 113.03L173.537 111.581Z",
  fill: "#0B1B2D"
});

function SvgNotavailable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 251,
    viewBox: "0 0 270 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotavailable);
export default __webpack_public_path__ + "static/media/notavailable.274e4f98.svg";
export { ForwardRef as ReactComponent };